module.exports = __webpack_public_path__ + "static/media/link_page_preview.703beafe.png";